import ContractTemplatesService from '@/services/contract-templates';
import ContractTemplatesInputTransformer from '@/transformers/input/contract-templates';

export default {
    namespaced: true,
    state: {
        templates: [],
        requestPending: false,
    },
    mutations: {
        setTemplates(state, templates) {
            if (!Array.isArray(templates)) {
                return;
            }
            state.templates = templates;
        },
        setRequestPending(state, requestPending) {
            state.requestPending = Boolean(requestPending);
        },
    },
    actions: {
        async getTemplates({ commit }, accountId = '') {
            try {
                commit('setRequestPending', true);
                const templates = await ContractTemplatesService.getTemplates(accountId);
                console.log('templates:', templates);
                
                const transformed = ContractTemplatesInputTransformer.transform(templates);
                commit('setTemplates', transformed);
            }
            catch (error) {
                throw error;
            }
            finally {
                commit('setRequestPending', false);

            }
        }
    },
}


// WEBPACK FOOTER //
// ./src/vuex/contract-templates/index.js